function utils() {
    async function handleSortChange (prop, order, sortSqlList) {
        let sortType = null
        if (order === "ascending") {
            sortType = "ASC"
        }else if (order === "descending") {
            sortType = "DESC"
        }

        let newSortSql = prop + " " + sortType
        if (sortSqlList.length > 0) {
            let sortAddStatus = false
            for (let i = 0; i < sortSqlList.length; i++) {
                let sortSql = sortSqlList[i]
                if (sortSql.indexOf(prop) !== -1) {
                    // 存在排序sql
                    sortSqlList.splice(i, 1)
                    if (order) {
                        sortSqlList.push(newSortSql)
                    }
                    sortAddStatus = true
                }
                if (i === sortSqlList.length - 1) {
                    if (!sortAddStatus) {
                        sortSqlList.push(newSortSql)
                    }
                }
            }
        }else {
            sortSqlList.push(newSortSql)
        }
    }
    return {
        handleSortChange
    }
}

export const pageUtil = utils()